import "./App.css";
import Navbar from "./components/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Home from "./components/Home";
import Cars from "./components/Cars";
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // This is CRUCIAL for carousel controls


import About from "./components/About";
import Contact from "./components/Contact";
import RentCar from "./components/RentCar";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <div id="home">
          <Home />
        </div>
        <div id="cars">
          <Cars />
        </div>
        <div id="rentcar">
          <RentCar />
        </div>
        <div id="about">
          <About />
        </div>
        <div id="contact">
          <Contact />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
